module.exports = __webpack_public_path__ + "static/assets/7eea42371f5ccb84b4fc7d0ba7331ea3.png";